import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import type { OfficersCardData } from '../types';
import '../membership.css';

interface Props {
  officers: OfficersCardData;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
}

const OfficersCard: React.FC<Props> = ({ officers }) => {
  const [open, setOpen] = useState(true);

  return (
    <Card className="ntcog-card dashboard-section-card membership-card officers-card mb-4">
      <Card.Header>
        <div className="membership-block">
          <h2 className="h5 mb-1">
            <button
              type="button"
              className="membership-caret btn btn-link btn-sm"
              aria-expanded={open}
              aria-controls="officers-tiles"
              onClick={() => setOpen((value) => !value)}
            >
              <span className="membership-caret__mark" aria-hidden="true">{open ? '▾' : '▸'}</span>
              Officers
            </button>
          </h2>
          <p className="membership-subtitle text-muted small mb-0">{officers.subtitle}</p>
        </div>
      </Card.Header>
      {open && (
        <Card.Body id="officers-tiles">
          <div className="row g-4">
            {officers.tiles.map((tile) => (
              <div className="col-12 col-md-6" key={tile.heading}>
                <h3 className="officers-role">
                  {tile.heading}
                  {tile.names.length > 0 && <span className="officers-role__count"> · {tile.names.length}</span>}
                </h3>
                {tile.names.length === 0 ? (
                  <p className="fst-italic text-muted mb-0">No one assigned yet</p>
                ) : (
                  <ul className="list-unstyled mb-0">
                    {tile.names.map((name) => (
                      <li className="officers-person" key={name}>
                        <span className="officers-person__initials" aria-hidden="true">{initials(name)}</span>
                        <span>{name}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default OfficersCard;
